import DeleteIcon from "@mui/icons-material/Delete";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { useDeleteRechnung } from "../../client/hooks";
import { useMutation, useQueryClient } from "react-query";
import {
  bindPopover,
  bindTrigger,
  usePopupState,
} from "material-ui-popup-state/hooks";

export default function DeleteRechnungenButton({ id }: { id: string }) {
  const mutate = useLoeschenRechnung(id);
  const popupState = usePopupState({
    variant: "popover",
    popupId: `lieferant-${id}-deactivate`,
  });
  return (
    <>
      <IconButton
        sx={{ marginTop: 3 }}
        {...bindTrigger(popupState)}
        aria-label="delete"
      >
        <DeleteIcon />
      </IconButton>
      <Dialog {...bindPopover(popupState)}>
        <DialogTitle id="alert-dialog-title">
          Eingangsrechnung wirklich löschen
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Sie sind dabei diese Eingangsrechnung zu löschen. Sind Sie sicher?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => popupState.close()} color="inherit">
            abbrechen
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              mutate.mutate();
              popupState.close();
            }}
          >
            löschen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
function useLoeschenRechnung(id: string) {
  const deleteRechnung = useDeleteRechnung();
  const queryClient = useQueryClient();

  return useMutation(
    () => {
      return deleteRechnung(id);
    },
    {
      onSuccess: async () => {
        queryClient.invalidateQueries(["rechnungen", id]);
      },
    }
  );
}
